import State from "./state";
// 方法

const mutations = {};

export default mutations;
